var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8077 0C14.4584 0 12.7362 0.949746 11.0707 1.86826C9.5345 2.71541 8.0835 3.51562 6.19231 3.51562C4.40456 3.51562 2.55754 2.58926 1.76923 2.14154V0H0V30H1.76923V18.1908C2.87671 18.7221 4.51832 19.3359 6.19231 19.3359C8.54155 19.3359 10.2638 18.3862 11.9293 17.4677C13.4655 16.6205 14.9166 15.8203 16.8077 15.8203C19.1532 15.8203 21.6011 17.415 21.6247 17.4305L23 18.3415V2.16633C21.1809 0.973594 18.9607 0 16.8077 0ZM21.2308 15.2076C20.1233 14.6763 18.4817 14.0625 16.8077 14.0625C14.4584 14.0625 12.7362 15.0122 11.0707 15.9308C9.5345 16.7779 8.0835 17.5781 6.19231 17.5781C4.40426 17.5781 2.55689 16.6515 1.76923 16.2041V4.12828C2.87671 4.65961 4.51832 5.27344 6.19231 5.27344C8.54155 5.27344 10.2638 4.32369 11.9293 3.40518C13.4655 2.55803 14.9166 1.75781 16.8077 1.75781C18.5956 1.75781 20.443 2.68441 21.2308 3.13184V15.2076Z",
    fill: "#6F76E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.e3404e51f05581766508d74e5f7cb619.svg";
export { ForwardRef as ReactComponent };